import { createSelector } from 'reselect';

import { getRegion } from '../filters';

import { selectCPDRegions } from './selectCPDRegions';

export const selectIsCurrentGeoInCPD = createSelector(getRegion, selectCPDRegions, (selectedGeo, cpdRegions) => {
  return cpdRegions.some(region => region.id === selectedGeo.id);
});
